import * as yup from 'yup';
import { withTranslation } from './withTranslation';
import { checkValidHttps } from './checkValidHttps';

const namePattern = /^[a-zA-Z\xC0-\uFFFF`]+([ \-'`]{0,1}[a-zA-Z\xC0-\uFFFF`]+){0,2}[.]{0,1}$/;
const EMAIL_REGEXP =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

const validationPattern = {
  firstName: yup
    .string()
    .min(2, withTranslation('auth', 'firstNameValidationMin'))
    .max(30, withTranslation('auth', 'firstNameValidationMax'))
    .matches(namePattern, withTranslation('auth', 'firstNameLetters'))
    .required(withTranslation('auth', 'firstNameRequired')),
  lastName: yup
    .string()
    .min(2, withTranslation('auth', 'lastNameValidationMin'))
    .max(30, withTranslation('auth', 'lastNameValidationMax'))
    .matches(namePattern, withTranslation('auth', 'lastNameLetters'))
    .required(withTranslation('auth', 'lastNameRequired')),
  oldPassword: yup
    .string()
    .test({
      name: 'isValidPass',
      skipAbsent: false,
      test(value, ctx) {
        if (value) {
          const messages: string[] = [];
          if (value.length < 8) {
            messages.push('passwordValidationMin');
          }
          if (!/[0-9]/.test(value)) {
            messages.push('passwordValidationNumber');
          }
          if (!/[a-z]/.test(value)) {
            messages.push('passwordValidationLowerLetter');
          }
          if (!/[A-Z]/.test(value)) {
            messages.push('passwordValidationUpperLetter');
          }
          if (!/[$&+,:;=?@#|'<>.^*()%!-]/.test(value)) {
            messages.push('passwordValidationSpecial');
          }
          if (messages.length) {
            const message = messages.map((e) => withTranslation('auth', `${e}`));
            return ctx.createError({ message: `${withTranslation('auth', 'passwordError')} ${message.join(', ')}` });
          }
        }
        return true;
      },
    })
    .required(withTranslation('auth', 'passwordRequiredOld')),
  password: yup
    .string()
    .test({
      name: 'isValidPass',
      skipAbsent: false,
      test(value, ctx) {
        if (value) {
          const messages: string[] = [];
          if (value.length < 8) {
            messages.push('passwordValidationMin');
          }
          if (!/[0-9]/.test(value)) {
            messages.push('passwordValidationNumber');
          }
          if (!/[a-z]/.test(value)) {
            messages.push('passwordValidationLowerLetter');
          }
          if (!/[A-Z]/.test(value)) {
            messages.push('passwordValidationUpperLetter');
          }
          if (!/[$&+,:;=?@#|'<>.^*()%!-]/.test(value)) {
            messages.push('passwordValidationSpecial');
          }
          if (messages.length) {
            const message = messages.map((e) => withTranslation('auth', `${e}`));
            return ctx.createError({ message: `${withTranslation('auth', 'passwordError')} ${message.join(', ')}` });
          }
        }
        return true;
      },
    })
    .required(withTranslation('auth', 'passwordRequired')),
  passwordNew: yup
    .string()
    .test({
      name: 'isValidPass',
      skipAbsent: false,
      test(value, ctx) {
        if (value) {
          const messages: string[] = [];
          if (value.length < 8) {
            messages.push('passwordValidationMin');
          }
          if (!/[0-9]/.test(value)) {
            messages.push('passwordValidationNumber');
          }
          if (!/[a-z]/.test(value)) {
            messages.push('passwordValidationLowerLetter');
          }
          if (!/[A-Z]/.test(value)) {
            messages.push('passwordValidationUpperLetter');
          }
          if (!/[$&+,:;=?@#|'<>.^*()%!-]/.test(value)) {
            messages.push('passwordValidationSpecial');
          }
          if (messages.length) {
            const message = messages.map((e) => withTranslation('auth', `${e}`));
            return ctx.createError({ message: `${withTranslation('auth', 'passwordError')} ${message.join(', ')}` });
          }
        }
        return true;
      },
    })
    .required(withTranslation('auth', 'passwordRequiredNew')),
  confirmPassWord: yup
    .string()
    .oneOf([yup.ref('password'), undefined], withTranslation('auth', 'confirmPasswordValidationMatch'))
    .required(withTranslation('auth', 'passwordRequired')),
  confirmPassWordAcc: yup
    .string()
    .oneOf([yup.ref('password'), undefined], withTranslation('auth', 'confirmPasswordValidationMatch'))
    .required(withTranslation('auth', 'passwordRequiredConfirm')),
  email: yup
    .string()
    .matches(EMAIL_REGEXP, withTranslation('auth', 'emailValidationIsValid'))
    .required(withTranslation('auth', 'emailRequired'))
    .max(150, withTranslation('auth', 'emailValidationMax')),
  code: yup.string().required(withTranslation('auth', 'codeRequired')),
  termsOfService: yup.boolean().oneOf([true], withTranslation('auth', 'acceptTerms')).required(),
  websiteUrl: yup
    .string()
    .test('is-valid-https', withTranslation('auth', 'notValid'), checkValidHttps)
    .required(withTranslation('auth', 'websiteUrlRequired')),
  companyName: yup
    .string()
    .min(1, withTranslation('auth', 'companyNameValidationMin')) // Ensures at least one non-space character
    .max(30, withTranslation('auth', 'companyNameValidationMax'))
    .required('Company name is required')
    .test(
      'no-spaces-only',
      'Company name cannot contain only spaces',
      (value) => value?.trim().length > 0
    ),

  industryField: yup.string()
  .required('Industry field  is required'),
  default: yup.string().required(),
};

export default validationPattern;
